import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { canVote } from '../Election';
import { getTranslator } from '../Translator';
import { NotFound } from './NotFound';
import { VoteResult } from '../_generatedTypes.g';
import { DocumentTitle } from './DocumentTitle';
import { getElectionById } from '../selectors';
import { ElectionContainer } from './election/ElectionContainer';
import { blankVote } from '../features/election/electionsSlice';
import { useAppSelector } from '../hooks';

type BlankVoteComponentParams = {
    electionId: string;
}

export const BlankVoteComponent = () => {
    const electionId = Number(useParams<BlankVoteComponentParams>().electionId);
    const language = useAppSelector(state => state.language);
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);
    const elections = useAppSelector(state => state.elections);
    const dispatch = useDispatch();

    const t = getTranslator(language);
    const election = getElectionById(elections, electionId);

    if (election) {
        return <ElectionContainer electionId={election.ElectionId}>
            <div>
                <h1>{t['Confirm blank vote']}</h1>
                <DocumentTitle title={t['Confirm blank vote']} />
                <table className="candidate__table">
                    <tbody>
                        <tr>
                            <th>{t['Election']}</th><td>{t.translate(election.Name)}</td>
                        </tr>
                    </tbody>
                </table>
                {canVote(election) ? <p>{t['Are you sure you want to issue a blank vote?']}</p> : null}
                <div className="buttonrow">
                    {canVote(election)
                        ? <button type="button" id="Blank-ConfirmVote" className="button--important" onClick={() => blankVote(election.ElectionId, token, dispatch)}>{t['Vote']}</button>
                        : <span className="linkbutton linkbutton--disabled">{t['Vote']}</span>}
                    <Link className="linkbutton" to={election.VoteResult === VoteResult.Success ? '/' : `/election/${election.ElectionId}`}>{t['Back']}</Link>
                </div>
            </div>
        </ElectionContainer>
    } else {
        return <NotFound />
    }
}
